import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "dark" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="bottom-center"
      visibleToasts={1}
      className="toaster group"
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "group toast w-full flex items-start gap-3 rounded-xl px-4 py-3.5 text-sm font-light tracking-wide shadow-xl border backdrop-blur-md " +
            "bg-[rgba(10,10,10,0.78)] border-[rgba(212,175,55,0.14)] text-white " +
            "dark:bg-[rgba(10,10,10,0.78)] dark:border-[rgba(212,175,55,0.14)] dark:text-white " +
            "[html:not(.dark)_&]:bg-[rgba(255,255,255,0.88)] [html:not(.dark)_&]:border-[rgba(212,175,55,0.18)] [html:not(.dark)_&]:text-[hsl(var(--charcoal))]",
          icon: "shrink-0 mt-0.5",
          title: "!text-[13px] !font-normal !tracking-wide !leading-snug",
          actionButton:
            "!ml-auto shrink-0 !bg-transparent !text-[hsl(var(--gold))] !border-0 !px-2 !py-1 !text-base !font-normal whitespace-nowrap",
          description:
            "!text-white/55 !text-[11.5px] !font-light !leading-relaxed !mt-1 min-w-0 " +
            "[html:not(.dark)_&]:!text-[hsl(var(--charcoal))]/60",
          content: "min-w-0 flex-1",
        },
      }}
      style={{
        paddingBottom: "env(safe-area-inset-bottom, 16px)",
      }}
      {...props}
    />
  );
};

export { Toaster };
